/*
 * Cart helpers shared by the browser cart and the server routes that price it.
 */
export const CART_STORAGE_KEY = 'tideline-cart'

export const MAX_CART_LINES = 30

export const MAX_LINE_QUANTITY = 20

export const lineKey = (productId: string, variant: string | null): string => {
    return `${productId}::${variant ?? ''}`
}

export const clampQuantity = (value: number): number => {
    if (!Number.isFinite(value)) return 1

    return Math.min(MAX_LINE_QUANTITY, Math.max(1, Math.floor(value)))
}
